module.exports = __webpack_public_path__ + "media/images/front/icons/login-28e8c37abf5f4c4adb60740003765f35.png";